import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import {
  useScroll,
  SecurityLogs as SecurityLogsList,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import { setTakeCount } from './store/slices/logs';
import { useLazyGetLocksAuditLogsQuery } from './store/services';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from './variables/logs';

import cn from './styles.module.css';

const SecurityLogs = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const {
    security: {
      logs: { logs, pagination, takeCount },
    },
    administrationDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const [getList, { isFetching, isLoading }] = useLazyGetLocksAuditLogsQuery();

  useScroll({
    element: scrollRef,
    requestInProgress: isFetching,
  });

  useEffect(() => {
    let title = 'Security Audit Logs';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      const { offsetHeight } = scrollRef.current;

      if (offsetHeight) {
        const take = offsetHeight / 58;

        dispatch(setTakeCount(Math.ceil(take + 3)));
      }
    }
  }, [scrollRef]);

  let content;

  if (!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SecurityLogsList
          logs={logs}
          pagination={pagination}
          takeCount={takeCount}
          activePermissions={activePermissions}
          schema={schema}
          getList={getList}
          isLoading={isLoading}
          filtersSchema={filtersSchema}
          columns={columns}
          columnsLabels={columnsLabels}
          isFetching={isFetching}
        />
        <Outlet />
      </>
    );
  }

  return (
    <div className={cn.securityLocksContent} ref={scrollRef}>
      {content}
    </div>
  );
};

export default SecurityLogs;
